import { render, staticRenderFns } from "./jsaRiskTab.vue?vue&type=template&id=81db69dc"
import script from "./jsaRiskTab.vue?vue&type=script&lang=js"
export * from "./jsaRiskTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81db69dc')) {
      api.createRecord('81db69dc', component.options)
    } else {
      api.reload('81db69dc', component.options)
    }
    module.hot.accept("./jsaRiskTab.vue?vue&type=template&id=81db69dc", function () {
      api.rerender('81db69dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/jsa/risk/jsaRiskTab.vue"
export default component.exports